'use client';

import Image from 'next/image';
import {
  ArrowUpRightIcon,
  ArrowUpLeftIcon,
  ArrowDownLeftIcon,
  ArrowDownRightIcon,
} from '@heroicons/react/20/solid';

import { useTranslations } from '@northladder/i18n';

/**
 * -----------------------------------------------------------------------------
 * This renders a canvas to test whether the user's touch is working.
 */
export function TouchScreenSwipeToReveal() {
  const t = useTranslations('TouchScreenInit');

  return (
    <div
      className="
        relative h-screen w-[375px]
        bg-[url('/images/assessment-images/imageOverlay.png')]
        bg-cover bg-center
      "
    >
      <div className="h-full w-full bg-stone-100 opacity-95">
        <ArrowUpRightIcon className="absolute right-[6.95px] top-[7.05px] z-10 h-6 w-6" />
        <ArrowUpLeftIcon className="absolute left-[6.95px] top-[7.05px] z-10 h-6 w-6" />
        <div
          className="
            absolute left-1/2 inline-flex h-10 w-[79px] -translate-x-1/2 transform
            items-center justify-center gap-1 rounded-3xl border
            border-gray-300 bg-white p-2
          "
        >
          1:00
        </div>

        <div className="flex h-full w-full flex-col items-center justify-center gap-24">
          <div
            className="
              bg-primary-300 relative flex h-52 w-52 items-center justify-center
              overflow-hidden rounded-full border-8 border-white
            "
          >
            <Image
              alt="Front white Screen"
              className="h-auto w-auto pt-20"
              height={300}
              priority
              src="/images/assessment-images/FRONT_WHITE.png"
              width={160}
            />
            <Image
              alt="Image Overlay"
              className="absolute bottom-0 h-auto w-auto rounded-[77.50px] mix-blend-multiply"
              height={152}
              src="/images/assessment-images/touchOverlay.png"
              width={145}
            />
          </div>
          <div className="flex flex-col items-center justify-center gap-2">
            <h1 className="text-center text-2xl font-bold leading-8 text-gray-800">
              {t('title')}
            </h1>
            <p className="text-center text-base font-medium leading-tight text-stone-900">
              {t('swipeScreen')}
            </p>
          </div>
        </div>
        <ArrowDownLeftIcon className="absolute bottom-[7.05px] left-[6.95px] z-10 h-6 w-6" />
        <ArrowDownRightIcon className="absolute bottom-[7.05px] right-[6.95px] z-10 h-6 w-6" />
      </div>
    </div>
  );
}
